import { createContext } from '@utils/createContext';

import type { QuestionsReporData } from '../types';

export const [ReportContext, useReport] = createContext<QuestionsReporData>();
